import {useCallback} from "react";
import {useQuery} from "@tanstack/react-query";
import {templateKeys} from "@/hooks/queries/queryKeys";
import {useBoundStore} from "@/hooks/queries/stores/use-bound-store";
import {useShallow} from "zustand/react/shallow";
import {DocumentTemplate, ProjectTemplate} from "@/pb/api/devplan/types/templates";

export interface AllTemplates {
  documentTemplates: DocumentTemplate[]
  projectTemplates: ProjectTemplate[]
}

export function useTemplates(): {
  templates: AllTemplates | undefined;
  loading: false | true;
  error: Error | null | undefined
} {
  const {fetchTemplates} = useBoundStore()
  const queryFn = useCallback(async () => {
    await fetchTemplates()
    return true
  }, [fetchTemplates])
  const queryKey = templateKeys.all

  const {data, isPending: loading, error} = useQuery({queryKey, queryFn})
  const templates = useCachedTemplates()
  return {templates: data ? templates : undefined, loading, error}
}

export function useCachedTemplates(): AllTemplates {
  const documentTemplates = useBoundStore(useShallow(s => Object.values(s.documentTemplates)))
  const projectTemplates = useBoundStore(useShallow(s => Object.values(s.templates)))
  return {documentTemplates, projectTemplates}
}